import { render, staticRenderFns } from "./assessmentPlan.html?vue&type=template&id=a923cc5a&scoped=true&external"
import script from "./assessmentPlan.vue?vue&type=script&lang=js"
export * from "./assessmentPlan.vue?vue&type=script&lang=js"
import style0 from "./assessmentPlan.css?vue&type=style&index=0&id=a923cc5a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a923cc5a",
  null
  
)

export default component.exports